'use client';

import { motion } from "motion/react";
import Image from 'next/image';
import { getTenantConfig } from "~/config/tenant-config";
import LoadingAnimation from './loading-animation';

const { logo } = getTenantConfig().branding;

const LoadingModal = ({ text, node }: { text?: string, node?: React.ReactNode }) => {
    return (
        <motion.div
            className='fixed -top-12 left-0 w-screen h-screen z-10'
            key="loading-modal"
            exit={{ opacity: 0 }}
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            transition={{ duration: .5 }}
        >
            <LoadingAnimation />

            <div
                className='w-[328px] h-[380px] bg-brand-background-white rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-md'
            >
                <div className='flex flex-col justify-center items-center h-full'>
                    <div className='flex flex-col justify-center items-center'>
                        <div className="z-10 text-center relative">
                            <span className="loader absolute -top-6"></span>
                            <Image
                                className="mx-auto my-6 absolute top-0 left-0 right-0"
                                src={logo.src}
                                alt={logo.alt}
                                width={logo.width}
                                height={logo.height}
                                style={{ width: "auto", height: "24px" }}
                                unoptimized={true}
                            />
                            <p className="font-bold">{text ?? "Analyzing your bill..."}</p>
                            {/* <p>9100 253 4668 5</p> */}
                            {node ? node : null}
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default LoadingModal;
